import React, { FC, useEffect } from 'react';
import { Route, Switch } from 'react-router';
import { useDispatch } from 'react-redux';
import routesByName from 'constants/routes';
import {
  AppDetail,
  AppsDashboard,
  CreateAppForm,
  NavBar,
  Page404,
  UIComponents,
  Footer,
} from 'modules';
import { getAllCountries, getAllAppCategories } from 'modules/userApps/store/actions';
import styles from './MainComponent.module.scss';
import { AccountDetailsModal, PasswordModal } from 'components/modals';

const MainComponent: FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllAppCategories());
    dispatch(getAllCountries());
    // dispatch(getAllLocales()); // not needed yet
  }, [dispatch]);

  return (
    <div className={styles.root}>
      <NavBar />
      <main className={styles.main}>
        <Switch>
          <Route exact path={routesByName.apps.index}>
            <AppsDashboard />
          </Route>
          <Route exact path={routesByName.apps.createApp}>
            <CreateAppForm />
          </Route>
          <Route path={routesByName.apps.detail.index()}>
            <AppDetail />
          </Route>
          <Route exact path={routesByName.ui}>
            <UIComponents />
          </Route>
          <Route path='*'>
            <Page404 />
          </Route>
        </Switch>
      </main>
      <Footer />
      <AccountDetailsModal />
      <PasswordModal />
    </div>
  );
};

export default MainComponent;
